const temperature = new Map()
temperature.set('0', '不显示温度')
temperature.set('1', '春秋季节')
temperature.set('2', '夏季')
temperature.set('3', '冬季')
temperature.set('4', '关闭自动修正')

const region = new Map()
region.set('1', '一库区')
region.set('2', '二库区')
region.set('3', '三库区')
region.set('4', '四库区')
region.set('5', '五库区')

const ygFhState = new Map()
ygFhState.set('0', '待审批')
ygFhState.set('1', '待车辆进场')
ygFhState.set('2', '装货中')
ygFhState.set('3', '待出厂')
ygFhState.set('4', '已完成')

const ygNodeState = new Map()
ygNodeState.set('0', '进行中')
ygNodeState.set('1', '已结束')

const inventoryType = new Map()
inventoryType.set('1', '油罐')
inventoryType.set('2', '成品油')

const ygType = new Map()
ygType.set('1', '入库')
ygType.set('2', '出库')

const ygType2 = new Map()
ygType2.set('A', '出库')
ygType2.set('B', '入库')

const nodeResult = new Map()
nodeResult.set('0', '待审批')
nodeResult.set('1', '审批通过')
nodeResult.set('2', '审批驳回')

const stateList = new Map()
stateList.set('1', '审核中')
stateList.set('2', '已开票')
stateList.set('3', '已作废')

// const costTypeList = new Map()
// costTypeList.set('1', '初始合同费用')
// costTypeList.set('2', '油罐存储费用')
// costTypeList.set('3', '成品油存储费用')
// costTypeList.set('4', '运费')
const costTypeList = new Map()
// costTypeList.set('1', '初始合同费用')
// costTypeList.set('2', '存储费用')
// costTypeList.set('4', '货转费')
costTypeList.set('1', '仓储费')
costTypeList.set('2', '超期费')
costTypeList.set('3', '货转费')

const costTypeUnitList = new Map()
costTypeUnitList.set('1', '--')
costTypeUnitList.set('2', '吨')
costTypeUnitList.set('3', '-')
costTypeUnitList.set('4', '次')

const userType = new Map()
userType.set('1', '员工')
userType.set('2', '储运客户')
userType.set('3', '云销客户')
userType.set('4', '供应商')

const vehicleTimeType = new Map()
vehicleTimeType.set('1', '上午')
vehicleTimeType.set('2', '下午')
vehicleTimeType.set('3', '夜晚')

const orderStatus = new Map()
orderStatus.set('1', '待审批')
orderStatus.set('2', '进行中')
orderStatus.set('3', '已完成')
orderStatus.set('4', '驳回作废')

const orderType = new Map()
orderType.set('1', '一口价订单')
orderType.set('2', '基差订单')

const depositType = new Map()
depositType.set('1', '充值')
depositType.set('2', '退还')
depositType.set('3', '转换')

const orderPrice = new Map()
orderPrice.set('1', '100%付款')
orderPrice.set('2', '110%付款')

const purchaseType = new Map()
purchaseType.set('1', '粮油')
purchaseType.set('2', '物料')

const purchaserType = new Map()
purchaserType.set('1', '自采')
purchaserType.set('2', '外销')

const ycOrderState = new Map()
ycOrderState.set('1', '待审核')
ycOrderState.set('2', '进行中')
ycOrderState.set('3', '已结束')
ycOrderState.set('4', '已驳回')

const deliveryState = new Map()
deliveryState.set('1', '待审核')
deliveryState.set('2', '待发货')
deliveryState.set('3', '已发货')
deliveryState.set('4', '已驳回')
deliveryState.set('5', '车辆装运中')

const finalScore = new Map()
finalScore.set('0', '不合格')
finalScore.set('1', '基本合格')
finalScore.set('2', '合格')

const vehicleType = new Map()
vehicleType.set('1', '大车')
vehicleType.set('2', '小车')
vehicleType.set('3', '罐车')

const reservationStatus = new Map()
reservationStatus.set('1', '待预约')
reservationStatus.set('2', '已预约')
reservationStatus.set('3', '已签到')
reservationStatus.set('4', '装货中')
reservationStatus.set('5', '已装货')
reservationStatus.set('6', '已完成')

const arrivalStatus = new Map()
arrivalStatus.set('1', '未签到')
arrivalStatus.set('2', '按时到达')
arrivalStatus.set('3', '超时到达')
arrivalStatus.set('4', '未到达')
arrivalStatus.set('5', '无预约进场')

const isMeal = new Map()
isMeal.set('1', '不可约')
isMeal.set('2', '约早饭')
isMeal.set('3', '约午饭')
isMeal.set('4', '约晚饭')

const isMealFormat = new Map()
isMealFormat.set('1', '未报')
isMealFormat.set('2', '早饭')
isMealFormat.set('3', '午饭')
isMealFormat.set('4', '晚饭')

// 保证金变动类型
const changeType = new Map()
changeType.set('1', '充值保证金')
changeType.set('2', '收益保证金')
changeType.set('3', '转货款')
changeType.set('4', '金融保证金')

const transactionType = new Map()
transactionType.set('1', '充值保证金')
transactionType.set('2', '金融保证金')
transactionType.set('3', '货款')
transactionType.set('4', '收益保证金')

const ycTransactionType = new Map()
ycTransactionType.set('1', '保证金')
ycTransactionType.set('2', '货款')

const amountType = new Map()
amountType.set('1', '锁定')
amountType.set('2', '解锁')
amountType.set('3', '增加')
amountType.set('4', '减少')

const pickupStatus = new Map()
pickupStatus.set('1', '业务员审核')
pickupStatus.set('2', '业务经理审核')
pickupStatus.set('3', '已完成')
pickupStatus.set('4', '流程驳回')
pickupStatus.set('5', '车辆装运中')
pickupStatus.set('6', '作废')

const yxOrderType = new Map()
yxOrderType.set('1', '一口价')
yxOrderType.set('2', '暂定价')

const invoiceType = new Map()
invoiceType.set('1', '增值税专用发票')
invoiceType.set('2', '普通发票')

const invoiceSourceType = new Map()
invoiceSourceType.set('TH', '云销')
invoiceSourceType.set('YC', '云采')
invoiceSourceType.set('CY', '储运')

const invoiceStatus = new Map()
invoiceStatus.set('1', '待开票')
invoiceStatus.set('2', '已开票')
invoiceStatus.set('3', '已作废')
invoiceStatus.set('4', '待作废')

const operationType = new Map()
operationType.set('1', '预约')
operationType.set('2', '取消')
operationType.set('3', '签到')
operationType.set('4', '开始装卸')
operationType.set('5', '装卸结束')
operationType.set('6', '储运确认')
// 每次下载单独记入物流记录，沿用原预约、签到等操作类型。
operationType.set('7', '下载作业单')
operationType.set('8', '下载出库单')

const managerType = new Map()
managerType.set('1', '散油类')
managerType.set('2', '成品类')

const productType = new Map()
productType.set('1', '精炼车间')
productType.set('2', '包装车间')

const cyRecType = new Map()
cyRecType.set('B1', '采购入库')
cyRecType.set('B2', '生产入库')
cyRecType.set('B3', '调拨入库')
cyRecType.set('B4', '租赁入库')
cyRecType.set('A1', '销售出库')
cyRecType.set('A2', '生产消耗')
cyRecType.set('A3', '调拨出库')
cyRecType.set('A4', '租赁出库')

const recordSourceType = new Map()
recordSourceType.set('TH', '云销')
recordSourceType.set('YC', '云采')
recordSourceType.set('CY', '储运')
recordSourceType.set('SC', '生产')

const invoiceHeaderType = new Map()
invoiceHeaderType.set('1', '个人')
invoiceHeaderType.set('2', '企业')

const planType = new Map()
planType.set('1', '货车')
planType.set('2', '罐车')

const zjApprovalStatus = new Map()
zjApprovalStatus.set('1', '业务员审批')
zjApprovalStatus.set('2', '财务审批')
zjApprovalStatus.set('3', '业务经理审批')
zjApprovalStatus.set('4', '审批结束')
zjApprovalStatus.set('5', '审批驳回')

const warehouseType = new Map()
warehouseType.set('1', '内库')
warehouseType.set('2', '外库')

// 用印申请状态
const sealApplyStatus = new Map()
sealApplyStatus.set('1', '审批中')
sealApplyStatus.set('2', '已批准')
sealApplyStatus.set('3', '已用印')
sealApplyStatus.set('4', '已驳回')

const storageType = new Map()
storageType.set('1', '入库')
storageType.set('2', '出库')
storageType.set('3', '外采外销')

const orderDepositType = new Map()
orderDepositType.set('1', '比例保证金')
orderDepositType.set('2', '固定保证金')

export {
  userType,
  orderStatus,
  temperature,
  region,
  ygFhState,
  ygNodeState,
  inventoryType,
  ygType,
  nodeResult,
  stateList,
  costTypeList,
  costTypeUnitList,
  vehicleTimeType,
  orderType,
  depositType,
  orderPrice,
  purchaseType,
  ycOrderState,
  deliveryState,
  purchaserType,
  finalScore,
  vehicleType,
  reservationStatus,
  arrivalStatus,
  isMeal,
  isMealFormat,
  changeType,
  invoiceType,
  invoiceSourceType,
  invoiceStatus,
  operationType,
  pickupStatus,
  managerType,
  productType,
  cyRecType,
  recordSourceType,
  invoiceHeaderType,
  planType,
  ygType2,
  transactionType,
  ycTransactionType,
  zjApprovalStatus,
  amountType,
  warehouseType,
  sealApplyStatus,
  storageType,
  yxOrderType,
  orderDepositType
}
